var iconAdd = require("@/assets/images/cloudSee/icon-add.png")
var iconError = require("@/assets/images/cloudSee/icon-error.png")
var iconUse = require("@/assets/images/cloudSee/icon-use.png")
var iconcloud = require("@/assets/images/cloudSee/icon-cloud.png")
var chevronRight = require("@/assets/images/cloudSee/chevron-right.png")

module.exports = {
    help: {
        title: "标题",
        search: "请输入您的问题",
        myDevice: "我的设备",
        // 常见问题
        problemArr: [
            {
                type: 1,
                title: "常见问题",
                contentData: [
                    {
                        imgLeft: iconAdd,
                        imgLight: chevronRight,
                        oneTitle: "添加设备",
                        content: [
                            {
                                twoTitle: "摄像机连接成功之后提示密码错误怎么处理？",
                                text: [
                                    "1.复位摄像机(复位步骤见“常见问题解答”中的“功能使用栏目”），删除APP设备栏里面的设备，重新配置摄像机连接的WiFi。",
                                    "2.多次复位摄像机，添加成功之后还是密码错误。把摄像机ID号提供给客服人员或者发送邮箱到support@sz-cloudbirds.com，我们会及时联系处理。",
                                ],
                            },
                            {
                                twoTitle: "设备提示“连接完成，欢迎使用”之后，设备栏设备显示离线",
                                text: [
                                    '1.重启路由器之后复位设备，删除设备栏离线设备，根据语音提示重新添加摄像机。',
                                    '2.换网络之后重新添加摄像机：换一个wifi重新添加摄像机，比如可以打开另外一台手机的手机热点，以此网络为摄像机所要连接的',
                                    '3.如果依然无法显示正常，请联系客服人员或发送至support@sz-cloudbirds.com邮箱。'
                                ],
                            },
                            {
                                twoTitle: "设备连接不上网络的可能因素有？",
                                text: [
                                    '1.路由器与设备的距离太远(尽量不超过10米，最大不超过20)或者设备与路由器之间存在干扰WiFi信号的阻隔物。',
                                    '2.WiFi名称以及密码有中文或者其他特殊符号; 如￥、@等符号。',
                                    '3.WiFi密码填写错误。',
                                    '4.设备是否启动正常。无线连接时设备会发出语言提示，有线连接可以捂住摄像头光敏二极管看是否有红外灯亮起。',
                                    '5.路由器设置了桥连模式，会因为wifi信号不稳定，导致连接失败。不建议摄像机联网使用桥连模式。',
                                    '6.摄像机WiFi信号接收弱（设备故障），手机直连摄像机发出的热点，观看监控是否有卡顿的现象。'
                                ],
                            },
                            {
                                twoTitle: "设备对网络有什么要求？",
                                text: [
                                    '1.不支持5GWiFi及企业级WiFi',
                                    '2.WiFi名称不能隐藏，路由器不能开启AP隔离，防蹭网等限制WiFi接入选项',
                                    '3.不支持IPv6网络',
                                    '4.确认摄像机不是连接光猫的WiFi（光猫的WiFi不稳定）',
                                    '5.设备所连接的网络最好上行带宽4M以上。上行带宽：一般是指从你的电脑上传的速度，也就说别人从你的电脑进行通讯的速率！'
                                ],
                            },
                            {
                                twoTitle: "[4G系列产品]充值完成后，仍旧无法连接，一直显示连接中怎么办？",
                                text: [
                                    '1.请联系客服人员并提供卡号进行刷新。',
                                    '2.刷新卡号后，将APP首页的设备删除后，复位重启设备再尝试连接。'
                                ],
                            },
                            {
                                twoTitle: "[4G系列产品]刚买回来的设备就无法连接，或者使用了一段时间后突然连接不上怎么办？",
                                text: [
                                    '1.确认当前设备卡号是否还有流量套餐，没有流量套餐无法进行连接。',
                                    '2.若是未曾使用过体验套餐，可以联系客服人员重置套餐。',
                                    '3.若是卡信号在当地不好，可联系客服人员更换其他卡商的卡。'
                                ],
                            },
                            {
                                twoTitle: "[4G系列产品]设备提示离线怎么办？",
                                text: [
                                    '1.检查卡内是否有套餐，更换设备位置以寻找更好的信号。',
                                    '2.将设备复位重启后再进行连接。',
                                    '3.是否卡信号不好，可联系客服人员更换其他卡商的卡。'
                                ],
                            },
                            {
                                twoTitle: "因为二维码无法识别或损坏无法连接怎么办？",
                                text: [
                                    '1.WiFi版可以使用设备扫描手机二维码进行连接。',
                                    '2.任何型号的设备都可以联系客服人员，提供购买的型号和设备ID领取电子二维码。'
                                ],
                            },
                        ],
                    },
                    {
                        imgLeft: iconError,
                        imgLight: chevronRight,
                        oneTitle: "故障排除",
                        content: [
                            {
                                twoTitle: "摄像机在使用过程中出现掉线，卡顿，反应慢怎么处理？",
                                text: [
                                    '1.更新APP和摄像机固件到最新版本。',
                                    '2.检查摄像机连接的或者当前网络环境是否通畅，摄像机与路由器的距离是否过远。',
                                    '3.复位摄像机重新配置网络。',
                                    '4.摄像机信号接收弱（设备故障），手机直连摄像机发出的热点，观看监控是否有卡顿的现象，如有该现象需更换摄像机。'
                                ],
                            },
                            {
                                twoTitle: "摄像机在局域网之内手机可以观看，外网观看不了？",
                                text: [
                                    '1.客户连接的是摄像机的热点，用4G网络或者其他WiFi就掉线了。',
                                    '2.客户是用是光猫设备，没有打开数据传输端口，可以让相应的运营商帮客户设置好光猫。',
                                    '3.修改路由器设置，把路由器的MTU（最大传输单元）值该为默认设置，然后重启路由器。',
                                    '4.设备和路由器断电重启，退出之后重新进入，确认设备是否可以正常监控。',
                                    '5.更新APP和摄像机固件到最新版本。',
                                    '6.复位设备重新添加。',
                                ]
                            },
                            {
                                twoTitle: "APP打开对讲，摄像机这边没有发出声音?",
                                text: [
                                    '1.苹果手机在 手机设置-千鸟物联-麦克风-开关要打开。',
                                    '2.安卓在 手机设置-应用-权限管理-千鸟物联-麦克风要打开。',
                                    '3.设备喇叭坏了，开机有没有提示语言可以判断。',
                                    '4.有该问题更新摄像机固件和版本。',
                                ]
                            },
                            {
                                twoTitle: "夜间监控画面一片漆黑或者白天监控画面发红?",
                                text: [
                                    '1.夜间监控画面发黑，先检查摄像机这边红外灯是否打开，其次在红外灯开启的情况下给设备重新上电看是否切换到正常画面；白天监控画面发红，重启设备看是否切换过来，以及重启存在问题请联系卖家处理。',
                                ]
                            },
                            {
                                twoTitle: "APP打开监听，手机接收不到摄像机发出的声音?",
                                text: [
                                    '1.手机声音没有打开，或者处于静音状态',
                                    '2.摄像机咪头损坏',
                                    '3.有该问题更新摄像机固件和版本',
                                ]
                            },
                            {
                                twoTitle: "相册里面的视频没有声音是什么原因？",
                                text: [
                                    '1.在设备监控页面进行屏幕录制的时候没有打开监听的功能',
                                ]
                            },
                            {
                                twoTitle: "摄像机SD卡录像没有录像文件？",
                                text: [
                                    '1.SD卡没有读取出来，断电重新插拔内存卡。',
                                    '2.SD卡损坏，更换新的内存卡。',
                                    '3.全时录像没有打开',
                                    '4.观察监控时间是否为当前时间，如果时间不正确，请在app主页点击设备右上角设置，点击时区设置，选择对应时区后点击右上角保存即可。',
                                    '5.更新摄像机固件和APP版本',
                                ]
                            },
                            {
                                twoTitle: "APP上面无法读取到内存卡的容量",
                                text: [
                                    '1.内存卡损毁掉。',
                                    '2.内存卡格式不正确，需要到电脑上面使用格式化内存卡。',
                                    '3.重新插拔内存卡。',
                                ]
                            },
                            {
                                twoTitle: "摄像机支持什么类型的内存卡",
                                text: [
                                    '1.速度：Class4及以上的都支持',
                                    '2.容量支持128G SD卡',
                                    '3.类型：TF卡',
                                    '4.分区格式：FAT32，exFAT',
                                ]
                            },
                            {
                                twoTitle: "摄像机显示时间不对如何调整？",
                                text: [
                                    '1.在APP主页，点击设备右上角设置，点击时区设置，选择北京时区（或客户所在地区时区），点击保存即可。',
                                ]
                            },
                            {
                                twoTitle: "语音对讲无法使用怎么办？",
                                text: [
                                    '1.设备重启是否有声音，若是有，可以手动检查是否正确打开了录音权限或手机的声音。',
                                    '2.若是开机无声音，可联系客服人员更换设备。',
                                ]
                            },
                            {
                                twoTitle: "摄像头的灯突然不正常的闪烁怎么办？",
                                text: [
                                    '1.这是因为设备正在升级中，稍等升级完成即可。',
                                ]
                            },
                            {
                                twoTitle: "全时录像被分成一段一段的，这是正常的么？",
                                text: [
                                    '1.这是正常的，防止录像加载的时间过长。',
                                ]
                            },
                            {
                                twoTitle: "OPPO手机弹出系统弹窗提示不适配怎么办？",
                                text: [
                                    '1.无视即可，不会对使用造成影响。',
                                ]
                            },
                            {
                                twoTitle: "APP识别不到内存卡怎么办？",
                                text: [
                                    '1.内存卡可能掉出或者没有接触好，可以打开设备的后盖查看内存卡是否插好，确认内存卡是否正常插入。若插好格式化后还要断电重启设备一次。',
                                ]
                            },
                            {
                                twoTitle: "内存卡不显示，无录像，无回放怎么办？",
                                text: [
                                    '1.查看TF卡容量以及TF卡状态，建议使用16G及以上的内存卡。',
                                    '2.检查设备的时间是否同步，根据“故障排除”中的设置时间教程设置时间。',
                                    '3.设置好时间后，关闭APP再打开，将录像设置关闭后再重新开启录像。',
                                    '4.等待一段时间后如果还是没有回放则检查APP版本是否更新。',
                                    '5.如果APP为最新版本却还是没有录像，则到维护设备--格式化内存卡--重启设备，等一段时间看看是否有录像。',
                                ]
                            },
                            {
                                twoTitle: "内存卡满了怎么办？",
                                text: [
                                    '1.新的录像会将之前的录像覆盖掉，如果不放心也可以进行TF卡格式化。建议使用16G及以上内存卡。',
                                ]
                            },
                            {
                                twoTitle: "无法切换为夜视怎么办？",
                                text: [
                                    '1.检查是否开启智能模式或红外模式，全彩模式下会打开白光灯不会切换夜视。',
                                ]
                            },
                            {
                                twoTitle: "[4G系列产品]如果卡片丢失或者二维码损坏怎么办？",
                                text: [
                                    '1.卡片丢失，可以打开后盖取出流量卡查看。',
                                    '2.二维码损坏时可以联系客服人员并提供设备ID领取电子二维码。',
                                ]
                            },
                        ],
                    },
                    {
                        imgLeft: iconUse,
                        imgLight: chevronRight,
                        oneTitle: "功能使用",
                        content: [
                            {
                                twoTitle: "如何复位摄像机",
                                text: [
                                    '1.在摄像机底部找到复位键或者复位孔，旁边会有 RESET 的英文字母。',
                                    '2.长按复位键三秒或者用取卡针戳小孔三秒（取卡针在配件的螺丝包里面有哦），等待摄像机发出“复位成功”的语音提示即可完成复位步骤。'
                                ],
                            },
                            {
                                twoTitle: "APP客户端支持那些手机系统？",
                                text: [
                                    '1.支持Android4.0以上版本已及iOS7.0以上版本手机系统。',
                                ],
                            },
                            {
                                twoTitle: "本地录像的分享",
                                text: [
                                    '1.打开相册打开相片或者录像视频点击分享按键，可以分享到其他的手机APP软件（微信，QQ）。',
                                ],
                            },
                            {
                                twoTitle: "如何删除录像",
                                text: [
                                    '1.SD卡录像：全部删除是直接在设置页面选择卡格式化。',
                                    '2.本地录像：在相册里面选择摄像机目录下不需要的照片和视频选择删除掉。',
                                ],
                            },
                            {
                                twoTitle: "如何分享设备？",
                                text: [
                                    '1.被分享者也必须下载并注册千鸟物联APP，分享者在APP首页点击摄像机的分享按钮，输入对方的账号或名称，被分享者同意即可。',
                                ],
                            },
                            {
                                twoTitle: "移动报警推送怎么打开？",
                                text: [
                                    '1.首先需要打开APP的通知权限，打开后打开APP中的报警功能中的报警推送，并将移动侦测调整到适合的距离，当有人经过时就会推送报警。',
                                ],
                            },
                            {
                                twoTitle: "如何更改清晰度？",
                                text: [
                                    '1.连接上设备后，进入查看时，点击全屏按钮后，就可以观察到超清或高清，点击即可修改。',
                                ],
                            },
                            {
                                twoTitle: "[4G系列产品]如何查看4G套餐内容？",
                                text: [
                                    '1.在千鸟物联APP中点击右下角我的，点击4G套餐充值，输入ICCID（卡号）后即可查看。',
                                    '2.可在APP主页面点击摄像机下方充值即可查看。',
                                ],
                            },
                            {
                                twoTitle: "[4G系列产品]如何查看设备ID和ICCID（卡号）？",
                                text: [
                                    '1.设备ID在机身上的二维码可以查看，ICCID在设备外部绑着的一张空卡片可以查看。',
                                    '2.如果手机APP绑定上设备可以直接点击设备设置按钮查看，如果没有绑定上就只能查看机身二维码或者外部空卡片。',
                                    '3.也可以打开设备后盖，取出内部的流量卡查看ICCID。',
                                ],
                            },
                        ],
                    },
                    {
                        imgLeft: iconcloud,
                        imgLight: chevronRight,
                        oneTitle: "云服务",
                        content: [
                            {
                                twoTitle: "同一时间仅支持几部手机登录？",
                                text: [
                                    "1.同一个账号在同一时间仅支持一部手机登录，暂不支持多设备同时登录。如：在手机A已登录账号C的情况下，手机B登录账号C，那么手机A在下拉刷新设备列表或重新开启APP时会被强制注销登录。",
                                    "2.>账号内的网络摄像机，请使用【分享设备】功能分享给家人。",
                                ],
                            },
                        ],
                    },
                ],
            },
            // {
            //     type: 2,
            //     title: "操作视频",
            //     contentData: [
            //         {
            //             oneTitle: "4G监控产品连接",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://birds-server-file.obs.cn-south-1.myhuaweicloud.com/file/video/cloudbirds/千鸟物联4G监控产品视频指导.mp4",
            //         },
            //         {
            //             oneTitle: "太阳能监控",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://birds-server-file.obs.cn-south-1.myhuaweicloud.com/file/video/cloudbirds/太阳能监控视频指导.mp4",
            //         },
            //         {
            //             oneTitle: "WIFI常电分享设备",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://birds-server-file.obs.cn-south-1.myhuaweicloud.com/file/video/cloudbirds/WIFI常电分享设备.mp4",
            //         },
            //         {
            //             oneTitle: "报警录像设置",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://birds-server-file.obs.cn-south-1.myhuaweicloud.com/file/video/cloudbirds/报警录像设置.mp4",
            //         },
            //         {
            //             oneTitle: "查看回放和录像文件",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://birds-server-file.obs.cn-south-1.myhuaweicloud.com/file/video/cloudbirds/查看回放和录像文件.mp4",
            //         },
            //         {
            //             oneTitle: "购买云存储的理由",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://birds-server-file.obs.cn-south-1.myhuaweicloud.com/file/video/cloudbirds/购买云存储的理由.mp4",
            //         },
            //         {
            //             oneTitle: "开启录像和查看录像",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://birds-server-file.obs.cn-south-1.myhuaweicloud.com/file/video/cloudbirds/开启录像和查看录像.mp4",
            //         },
            //         {
            //             oneTitle: "录像模式设置",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://birds-server-file.obs.cn-south-1.myhuaweicloud.com/file/video/cloudbirds/录像模式设置.mp4",
            //         },
            //         {
            //             oneTitle: "设备音量调节",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://birds-server-file.obs.cn-south-1.myhuaweicloud.com/file/video/cloudbirds/设备音量调节.mp4",
            //         },
            //         {
            //             oneTitle: "摄像机对讲设置",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://birds-server-file.obs.cn-south-1.myhuaweicloud.com/file/video/cloudbirds/摄像机对讲设置.mp4",
            //         },
            //         {
            //             oneTitle: "双光源介绍",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://birds-server-file.obs.cn-south-1.myhuaweicloud.com/file/video/cloudbirds/双光源介绍.mp4",
            //         },
            //         {
            //             oneTitle: "云存储购买和使用",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://birds-server-file.obs.cn-south-1.myhuaweicloud.com/file/video/cloudbirds/云存储购买和使用.mp4",
            //         },
            //     ],
            // },
        ],
        yes: '已解决',
        no: '未解决',
        share: '分享',
        noDevice: '暂无设备',
        operationVideo: '操作视频',
        loading: '加载中...',
        pageTitle: '帮助与反馈',
        customerService: '专属客服',
        usertermsTitle: '用户协议',
        privacyPolicyTitle: '隐私政策',
        philipsCloudServiceTitle: '云服务购买协议',
        philipsAutoRenewTitle: '自动续费协议',
        birdsDetectionServiceTitle: '智能侦测服务协议',
        birdsAIDetectionServiceTitle: '全能AI服务协议',
        birdsDetectionAutoRenewTitle: '智能侦测服务自动续费协议',
        rechargeTitle: '流量充值',
        infoListTitle: '个人信息清单及SDK共享清单',
        userInfoTitle: '用户身份信息',
    }
}  